<template>
  <tr>
    <td>{{ row.date }}</td>
    <td>{{ row.pay ? toCurrency(row.pay, currency) : '–' }}</td>
    <td>{{ row.act ? toCurrency(row.act, currency) : '–' }}</td>
    <td>
      <span :class="statusClass(row.status)">
        {{ status(row.status) }}
      </span>
    </td>
  </tr>
</template>

<script>
import Helper from '@/classes/helper'
import { mapState } from 'pinia/dist/pinia'
import { useDocsStore } from '@/stores/docs'
import { useFinStore } from '@/stores/fin'

export default {
  name: 'DocsRow',
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useDocsStore, ['statusList']),
    ...mapState(useFinStore, ['currency']),
  },
  methods: {
    toCurrency: Helper.toCurrency,
    status(status) {
      return this.statusList[status]
    },
    statusClass(status) {
      switch (status) {
        case ('2'):
        case ('4'):
          return ['table-inside__status', 'table-inside__status-5']
        case '1':
          return ['table-inside__status', 'table-inside__status-3']
        case '3':
          return ['table-inside__status', 'table-inside__status-2']
        default:
          return ['table-inside__status']
      }
    },
  },
}
</script>
